import { Api } from './generated/ApiClient';

/**
 * Learning Backend API Client
 *
 * Configured instance of the API client for the Learning App backend.
 * This client is automatically generated from the Swagger specification.
 *
 * @example
 * ```typescript
 * import { apiClient } from '@/api/client';
 *
 * // Fetch learning objects
 * const response = await apiClient.adobe.getLearningObjects({
 *   searchRequest: { pageLimit: 10 }
 * });
 * ```
 */

// Determine the base URL based on environment
// const getBaseUrl = (): string => {
//   // In development, you might want to use a different base URL
//   if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_API_BASE_URL) {
//     return process.env.REACT_APP_API_BASE_URL;
//   }

//   // Default to staging
//   return 'https://learning-app.us-east-1.staging.atl-paas.net';
// };

// Create and configure the API client
export const apiClient = new Api({
  baseUrl: 'https://community-ui.adev.frontend.public.atl-paas.net/gateway/api/learning-app',
  baseApiParams: {
    credentials: 'include', // Include cookies for authentication
    headers: {
      'Content-Type': 'application/json',
    },
    format: 'json',
  },
});

// Export the Api class for custom instances if needed
export { Api } from './generated/ApiClient';
